export default __webpack_public_path__ + "static/media/edits.c29f4f2c.svg";